export enum LabelTextFieldType {
    SIGNATURE = "SIGNATURE",
    DOCUMENT_VERSION = "DOCUMENT_VERSION",
    FREE = "FREE"
}
